import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Paginate } from "../../../components/paginate";
import {
  SearchResponse,
  TenderSearchInput,
  TenderSearchState,
  updateSearchFilters,
} from "../../../hooks/slices/tenderSearchSlice";
import { GenericSearchPageProps, SearchConfiguration } from "../GenericSearchPage";
import { SearchResultsBody, SearchResultsBodySkeleton } from "./body/SearchResultsBody";
import { SearchResultsHeader, SearchResultsHeaderSkeleton } from "./header/SearchResultsHeader";
import { SearchType } from "../../../consts/searchType";
import { RaiseCurrentPlan } from "../../../hooks/raiseCurrentPlan";
import { FeatureUtil } from "../../../utils/features";
import { FeatureName } from "../../../consts/features";
import { PlanDto } from "../../../hooks/slices/currentPlanSlice";
import { UserInteraction } from "../../../hooks/slices/userSlice";
import { RaiseUser } from "../../../hooks/raiseUser";
import {SearchHintBanner} from "../../../components/searchHint";

export const SearchResults: React.FC<GenericSearchPageProps> = (props) => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const lang = i18n.language; // something like en-US
  const languageIso = lang.substring(0, 2).toUpperCase(); // just becomes EN todo convert this to Language (via UserLanguage())
  const tenderSearchOutput: SearchResponse | undefined = useAppSelector((state) => state.tenderSearch.searchResponse);
  let userInteractions: UserInteraction[] = RaiseUser().user?.userInteractions ?? [];
  const tenderSearchInputWithFilters: TenderSearchInput | undefined = useAppSelector(
    (state) => state.tenderSearch.searchInput
  );
  const currentPlan: PlanDto | undefined = RaiseCurrentPlan().currentPlan;
  //When a user has a limited amount of opportunities per update mail, they cannot use the filters in opportunities
  const tenderSearchInStore: TenderSearchState = useAppSelector((state) => state.tenderSearch);
  let opportunitiesLimit: number | undefined;
  if (tenderSearchInStore.searchType === SearchType.OPPORTUNITIES) {
    opportunitiesLimit = FeatureUtil.getFeatureLimit(currentPlan?.features, FeatureName.UPDATE_MAIL_OPPORTUNITIES);
  }
  const setPage = (page: number) => {
    dispatch(updateSearchFilters({ page: page, userInteractions: userInteractions }));
  };
  if (
    tenderSearchOutput === undefined ||
    tenderSearchOutput.tenders === undefined ||
    tenderSearchInputWithFilters === undefined ||
    props.searchConfiguration.sidebar.queryType === SearchType.DUMMY
  ) {
    return <SearchResultsSkeleton {...props.searchConfiguration} />;
  }
  if (tenderSearchInputWithFilters.metadata.sortBy === "AWARD_DATE_DESC") {
    props.searchConfiguration.tenderCard.showAwardDateInsteadOfDeadline = true;
  }
  return (
    <>
      <div>
        <div className="search-filter-section-alignment">
          <SearchHintBanner/>
          <SearchResultsHeader
            tenderSearchInput={tenderSearchInputWithFilters.mainInput}
            tenderSearchOutput={tenderSearchOutput}
            searchConfiguration={props.searchConfiguration}
            opportunitiesLimit={opportunitiesLimit}
            initialSearchFilterState={props.initialSearchFilterState}
          />
          <SearchResultsBody
            searchHits={tenderSearchOutput.tenders}
            languageIso={languageIso}
            cardConfiguration={props.searchConfiguration.tenderCard}
          />
          <Paginate
            currentPage={tenderSearchOutput.page}
            totalHits={tenderSearchOutput.totalHits}
            setPage={setPage}
            itemsPerPage={tenderSearchOutput.pageSize}
            maxPages={props.searchConfiguration.info.maxPages}
          />
        </div>
      </div>
    </>
  );
};



export const SearchResultsSkeleton: React.FC<SearchConfiguration> = (props) => {
  return (
    <>
      <div>
        <div className="search-filter-section-alignment">
          <SearchResultsHeaderSkeleton {...props} />
          <SearchResultsBodySkeleton />
        </div>
      </div>
    </>
  );
};
